const formatValue = (value, isCurrency, label) => {
  const safeValue = Number(value) || 0;

  if (label === "Total Bookings") return safeValue;

  if (isCurrency) {
    return new Intl.NumberFormat("en-PK", {
      style: "currency",
      currency: "PKR",
      maximumFractionDigits: 0,
    }).format(safeValue);
  }

  return new Intl.NumberFormat("en-PK", {
    maximumFractionDigits: 0,
  }).format(safeValue);
};

const StatsCard = ({ label, value, tone = "primary", isCurrency = false, icon: Icon }) => {
  return (
    <div className="widget-stat card h-100">
      <div className="card-body p-3">
        <div className="media ai-icon align-items-center">
          <span
            className={`me-3 bgl-${tone} text-${tone}`}
            style={{
              width: 42,
              height: 42,
              minWidth: 42,
              fontSize: "1rem",
              borderRadius: "50%",
              padding: 0,
            }}
          >
            {Icon ? <Icon size={18} /> : null}
          </span>
          <div className="media-body">
            <p className="mb-1">{label}</p>
            <h4 className="mb-0">{formatValue(value, isCurrency, label)}</h4>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatsCard;
